export const RESERVATION_FETCH_SUCCESS = 'RESERVATION_FETCH_SUCCESS';
export const RESERVATION_CLEAR = 'RESERVATION_CLEAR';

export const reservationFetchSuccess = (payload) => ({
  type: RESERVATION_FETCH_SUCCESS,
  payload
});

export const reservationClear = () => ({
  type: RESERVATION_CLEAR
});